<template>
    <div class="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>
                <router-link class="btn btn-sm" :to="{ name: 'RoutingGroupList' }"
                  ><i class="fas fa-chevron-left"></i>
                </router-link>
                Routing BGP Router
              </h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Home' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Routing BGP Router</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section class="content">
        <div class="container-fluid">
          <div class="card" id="RoutingBGPRouter">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
              </div>
              <div class="card-body pb-1">
                <div class="row">
                  <div class="col-md-8">

                    <div class="form-group required">
                      <label class="control-label">Name</label>
                      <input
                        type="text"
                        id="bgp_name"
                        name="bgp_name"
                        v-bind:class="{ 'has-error': errors.has('bgp_name') }"
                        v-validate="{ required: true, regex: /^[A-Za-z_]+$/}"
                        v-model="value.bgp_name"
                        :readonly="is_edit"
                        class="form-control bgp_name"
                        placeholder="Name"
                      />
                      <div class="help text-danger" v-show="errors.has('bgp_name')">
                        {{ `The name should only contains alphabet and underscrore.` }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">AS</label>
                      <input
                        type="text"
                        id="bgp_as"
                        name="as"
                        v-validate="'required|numeric|max:11'"
                        :readonly="is_edit"
                        v-bind:class="{ 'has-error': errors.has('bgp_as') }"
                        v-model="value.bgp_as"
                        class="form-control bgp_as"
                        placeholder="AS"
                      />
                      <div class="help text-danger" v-show="errors.has('as')">
                        {{ errors.first("as") }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Router ID</label>
                      <input
                        type="text"
                        id="router_id"
                        name="router id"
                        v-validate="'required|ip'"
                        v-bind:class="{ 'has-error': errors.has('router_id') }"
                        v-model="value.router_id"
                        class="form-control router_id"
                        placeholder="Router ID"
                      />
                      <div class="help text-danger" v-show="errors.has('router id')">
                        {{ errors.first("router id") }}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="card-footer pt-0 pb-4">
                <button type="submit" v-if="!is_edit" class="btn">Submit</button>
                <button type="submit" v-if="is_edit" class="btn">Update</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "RoutingBGPRouterForm",
  metaInfo: {
    title: "Routing BGP Router| Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
    },
    pre: {
    },
  }),

  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/routing_bgp_routers";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/routing_bgp_routers/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: 'RoutingGroupList' });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/routing_bgp_routers/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      const _this = this
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }
      this.is_loading = false;
    },

  },
  mounted() {
    this.initialize();
  },
};
</script>
